var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"f-auto-resize-input"},[_vm._t("default"),_c('span',{ref:"twin",staticClass:"hidden-twin"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }